export const ERRORS_DICTIONARY: Record<string, string> = {
  AliasExistsException:
    'An account with the given email or phone number already exists.',
  CodeDeliveryFailureException:
    'We encountered an issue while trying to send the verification code. Please check your email or phone number and try again.',
  CodeMismatchException:
    'The code you entered is not valid. Please double-check the code and try again.',
  CognitoIdentityProviderServiceException:
    'An error occurred with the Cognito Identity Provider service.',
  ConcurrentModificationException:
    'Concurrent modification of the resource occurred.',
  DuplicateProviderException: 'The provider is already linked to a user.',
  EnableSoftwareTokenMFAException: 'Failed to enable software token MFA.',
  ExpiredCodeException:
    'The verification code you entered has expired. Please request a new code and try again.',
  ForbiddenException: 'You do not have permission to perform this action.',
  GroupExistsException: 'This group already exists.',
  InternalErrorException: 'An internal error has occurred, please try again.',
  InvalidEmailRoleAccessPolicyException:
    'The email role access policy is not valid.',
  InvalidLambdaResponseException: 'Invalid response from the Lambda function.',
  InvalidOAuthFlowException: 'The specified OAuth flow is not valid.',
  InvalidParameterException: 'Invalid parameter: ',
  InvalidPasswordException: 'Invalid password: ',
  InvalidSmsRoleAccessPolicyException:
    'The SMS role access policy is not valid.',
  InvalidSmsRoleTrustRelationshipException:
    'The SMS role trust relationship is not valid.',
  InvalidUserPoolConfigurationException:
    'The user pool configuration is not valid.',
  LimitExceededException: 'Attempt limit exceeded, please try after some time.',
  MFAMethodNotFoundException: 'The specified MFA method is not found.',
  NotAuthorizedException: 'Incorrect username or password.',
  PasswordHistoryPolicyViolationException:
    'This password was used recently. Please choose a different password.',
  PasswordResetRequiredException: 'Password reset is required.',
  PreconditionNotMetException: 'A precondition for the request is not met.',
  ResourceNotFoundException: 'The requested resource was not found.',
  RiskExceptionConfigurationType: 'Risk configuration exception occurred.',
  ScopeDoesNotExistException: 'The specified scope does not exist.',
  SoftwareTokenMFANotFoundException: 'The software token MFA is not found.',
  TooManyFailedAttemptsException:
    'Too many failed attempts, please try again later.',
  TooManyRequestsException: 'Too many requests, please try again later.',
  UnauthorizedException:
    'The request is not authorized. This can happen due to an invalid access token.',
  UnexpectedLambdaException:
    'An unexpected error occurred with the Lambda function.',
  UnsupportedIdentityProviderException:
    'The specified identity provider is not supported.',
  UnsupportedOperationException: 'The operation is not supported.',
  UnsupportedTokenTypeException: 'The specified token type is not supported.',
  UnsupportedUserStateException: 'The user is in an unsupported state.',
  UserImportInProgressException: 'A user import job is in progress.',
  UserLambdaValidationException:
    'The provided password does not meet the requirements.',
  UserNotConfirmedException: 'User is not confirmed.',
  UserNotFoundException: 'User does not exist.',
  UserPoolAddOnNotEnabledException: 'The user pool add-on is not enabled.',
  UserPoolTaggingException: 'The user pool tagging operation failed.',
  UsernameExistsException: 'An account with the given email already exists.',
  UserAlreadyAuthenticatedException: 'There is already a signed in user.',
};

export enum ERROR_TYPE {
  WARNING = 'WARNING',
  ERROR = 'ERROR',
  INFO = 'INFO',
}
